import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  SelectProps as MuiSelectProps,
} from '@mui/material';

export interface SelectOption {
  value: string | number;
  label: string;
  disabled?: boolean;
}

export interface SimpleSelectProps extends Omit<MuiSelectProps, 'name' | 'value' | 'onChange' | 'label' | 'displayEmpty'> {
  value: string | number;
  onChange: (value: string | number) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  helperText?: string;
  options: SelectOption[];
  displayEmpty?: boolean;
  emptyLabel?: string;
  error?: boolean;
}

export function SimpleSelect({
  value,
  onChange,
  label,
  disabled,
  required,
  helperText,
  options,
  displayEmpty,
  emptyLabel = 'Select an option',
  error,
  ...selectProps
}: SimpleSelectProps) {
  const labelId = `simple-select-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <FormControl fullWidth error={error}>
      {label && (
        <InputLabel id={labelId}>
          {label}
          {required && ' *'}
        </InputLabel>
      )}
      <MuiSelect
        {...selectProps}
        value={value}
        onChange={(event) => onChange(event.target.value as string | number)}
        labelId={labelId}
        label={label}
        disabled={disabled}
        displayEmpty={displayEmpty}
      >
        {displayEmpty && (
          <MenuItem value="">
            <em>{emptyLabel}</em>
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </MenuItem>
        ))}
      </MuiSelect>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}